import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Header        from '../partials/header';
import ApiLoading    from '../partials/api-loading';

import Pages         from '../config/pages';

global.__base = __dirname + '/';
// -------------------------------------------------------

class Index extends React.Component
{
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.initState(props);
    
    // スタイル設定
    require('css_style1');
    //require('css_style2');
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  initState(props) {
    let serverData = window.__DATA__;
    let wrapped = serverData.data || {};
    let data = wrapped.data || {};
    data.page   = wrapped.page;
    data.navi   = wrapped.navi;
    data.header = wrapped.header;
    data.bundle = wrapped.bundle;
    data.event = {
      updateData : this.updateData.bind(this),
    }

    this.state = {
      data : data,
    };
  }
  // -------------------------------------------------------
  
  /*
   * データの更新
   */
  updateData(column, update) {
    let data = this.state.data;
    data[column] = update;
    this.setState({ data: data });
  }
  // -------------------------------------------------------
  
  /*
   * 出力処理
   */
  render() {
    let serverData = window.__DATA__;
    let page = serverData.data.page;
    
    return (
      <div id="index">
        <ApiLoading />
        
        <Header page={page} data={serverData.data} />
        { Pages.getPages(page, this.state.data) }
      </div>
    )
  }
  // -------------------------------------------------------
}

// レンダリング処理
ReactDom.render(
  <div>
    <Index />
  </div>
  , document.getElementById('contents')
);